// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/responsive-image/responsive-image.component.scss
// module id = 481
// module chunks = 0